import type { NavigationModuleBehavior } from '@core/ui/navigation';

export const navigationModuleConfig = {
  behavior: {
    enableSubmenus: true,
    mobileExpandInline: true,
    closeOnOutsideClick: true,
    dropdownTrigger: 'hover',      
  } as NavigationModuleBehavior,
}; 